import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'
import {ChangePasswordForm} from '../../components/ChangePasswordForm/ChangePasswordForm'
import './PerfilVendedor.css'

const validatePhone = (value) => {
  const phone = value.trim()
  const hasControlCharacters = Array.from(phone).some((character) => {
    const code = character.codePointAt(0)
    return code <= 31 || code === 127
  })
  if (phone.length > 40 || hasControlCharacters)
    return 'Ingresa un teléfono válido de máximo 40 caracteres.'
  return null
}

function PerfilVendedor() {
  const API_URL = process.env.REACT_APP_API_URL
  const [profile, setProfile] = useState(null)
  const [phone, setPhone] = useState('')
  const [loading, setLoading] = useState(true)
  const [savingPhone, setSavingPhone] = useState(false)
  const [message, setMessage] = useState(null)

  useEffect(() => {
    axios
      .get(`${API_URL}/perfil-vendedor`)
      .then(({data}) => {
        setProfile(data.data)
        setPhone(data.data?.telefono || '')
      })
      .catch((error) =>
        setMessage({
          type: 'danger',
          text: error.response?.data?.message || 'No fue posible cargar tu perfil.',
        })
      )
      .finally(() => setLoading(false))
  }, [API_URL])

  const savePhone = async (event) => {
    event.preventDefault()
    setMessage(null)
    const validationError = validatePhone(phone)
    if (validationError) {
      setMessage({type: 'danger', text: validationError})
      return
    }

    setSavingPhone(true)
    try {
      const {data} = await axios.put(`${API_URL}/perfil-vendedor`, {telefono: phone.trim()})
      const savedPhone = data.data?.telefono || ''
      setPhone(savedPhone)
      setProfile((current) => ({...current, telefono: savedPhone}))
      setMessage({type: 'success', text: data.message || 'Teléfono actualizado correctamente.'})
    } catch (error) {
      setMessage({
        type: 'danger',
        text: error.response?.data?.message || 'No fue posible actualizar tu teléfono.',
      })
    } finally {
      setSavingPhone(false)
    }
  }

  const readonlyFields = [
    ['Clave', profile?.clave],
    ['Nombre', profile?.nombre],
    ['Correo electrónico', profile?.email],
  ]

  return (
    <LoadingOverlay active={loading} spinner text='Cargando perfil...'>
      <div className='perfil-vendedor'>
        <header>
          <h1>Mi Perfil</h1>
          <p>Consulta tus datos registrados y actualiza tu teléfono o contraseña.</p>
        </header>
        {message && (
          <div className={`alert alert-${message.type}`} role='status'>
            {message.text}
          </div>
        )}
        <section>
          <h2>Información general</h2>
          <div className='perfil-vendedor-grid'>
            {readonlyFields.map(([label, value]) => (
              <div className='perfil-vendedor-field' key={label}>
                <span>{label}</span>
                <strong>{value || 'No disponible'}</strong>
              </div>
            ))}
            {profile && (
              <form className='perfil-vendedor-phone-form' onSubmit={savePhone} noValidate>
                <label className='perfil-vendedor-phone-field'>
                  <span>Teléfono</span>
                  <div className='perfil-vendedor-phone-controls'>
                    <input
                      className='form-control'
                      type='tel'
                      maxLength='40'
                      value={phone}
                      onChange={(event) => {
                        setPhone(event.target.value)
                        setMessage(null)
                      }}
                    />
                    <button className='btn btn-primary' type='submit' disabled={savingPhone}>
                      {savingPhone ? 'Guardando...' : 'Guardar'}
                    </button>
                  </div>
                </label>
              </form>
            )}
          </div>
        </section>
        <section>
          <h2>Contraseña y seguridad</h2>
          <ChangePasswordForm endpoint='perfil-vendedor-password' />
        </section>
      </div>
    </LoadingOverlay>
  )
}

export {PerfilVendedor}
